/**
 * @module services/axios
 */

import axios from 'axios';

axios.defaults.baseURL = import.meta.env.VITE_BASE_URL;
// axios.interceptors.response.use( response => response, error => Promise.reject(error.response || error) );

function consumeCancellation(ev) {
	if (ev && ev.reason && axios.isCancel(ev.reason)) {
		ev.preventDefault();
	}
}

window.addEventListener('unhandledrejection', consumeCancellation);

export const CancelToken = axios.CancelToken;

export default axios;
